import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { Title } from './developers/page-components/Title';
import { EditBlock } from './profileSettings/EditBlock';
import { Spinner } from './Spinner';
import './SectionWrapper.scss';

interface ISectionWrapperProps {
	sectionAdditionalClass?: string;
	sectionBodyAdditionalClass?: string;
	title?: string;
	children: ReactNode;
	isCardBody?: boolean;
	isEditMode?: boolean;
	setIsEditMode?: (value:boolean) => void;
	onEditClick?: () => void;
	loading?: boolean;
	pageLoading?: boolean;
}

export const SectionWrapper = (props: ISectionWrapperProps): JSX.Element => {
	const {
		sectionAdditionalClass,
		sectionBodyAdditionalClass,
		title,
		isCardBody,
		isEditMode,
		setIsEditMode,
		onEditClick,
		children,
		loading,
		pageLoading
	} = props;

	const mainInformation = pageLoading ? <Spinner pageLoader/> : children;

	return (
		<div className={clsx('card', sectionAdditionalClass)}>
			{
				title && (
					<div className="card-header d-flex align-items-center justify-content-between">
						<Title title={title} additionalClass="fs-5 fw-bolder"/>
						{
							onEditClick && (
								<EditBlock
									isEditMode={isEditMode}
									setIsEditMode={setIsEditMode}
									onEditClick={onEditClick}
									loading={loading}
								/>
							)
						}
					</div>
				)
			}
			{
				isCardBody
					? (
						<div className={clsx('card-body', sectionBodyAdditionalClass)}>
							{mainInformation}
						</div>
					)
					: mainInformation
			}
		</div>
	);
};
